import { useConfigContext } from 'contexts/config';

export const useEnabledWheelByRarity = () => {
  const { wheel } = useConfigContext();

  return {
    limited: wheel.limitedWheelConfig !== null,
    common: wheel.commonWheelConfig !== null,
  };
};
